import { useDatePickerContext } from '../DatePickerContext/DatePickerContext.js';

var useDatePickerPrevMonthButton = function () {
    var _a = useDatePickerContext(), size = _a.size, checkIsDisabled = _a.checkIsDisabled, prevMonth = _a.prevMonth, navigateDate = _a.navigateDate;
    var prevMonthClickHandler = function (e) {
        e.preventDefault();
        navigateDate(prevMonth, true);
    };
    return {
        props: {
            size: size,
            direction: "left",
            label: "Previous month",
            onClick: prevMonthClickHandler,
            disabled: checkIsDisabled(prevMonth),
        },
    };
};

export { useDatePickerPrevMonthButton };
//# sourceMappingURL=useDatePickerPrevMonthButton.js.map
